import { useState, useEffect } from 'react';
import { Button, Typography, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

const PREFIX = 'OrganisationOutOfCreditNotice';

const classes = {
  notice: `${PREFIX}-notice`,
};

const Root = styled('div')(({ theme }) => ({
  [`& .${classes.notice}`]: {
    padding: theme.spacing(2, 5),
    backgroundColor: '#f8a897',
    textAlign: 'center',
    color: '#8a1a17',
    '& button': {
      [theme.breakpoints.up('md')]: {
        width: '400px',
      },
    }
  },

}));

interface IProps {
  showNotice: boolean;
}

export default function OrganisationOutOfCreditNotice(props: IProps) {
  const {
    showNotice,
  } = props;

  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(showNotice);
  }, [showNotice]);

  if (!open) {
    return <></>;
  }

  return (
    <Root>
      <Paper className={classes.notice}>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bolder' }}>
          Notice
        </Typography>
        <Typography variant="subtitle1" gutterBottom>
          You have 0 credits remaining, you cannot score new companies.
        </Typography>
        <Button variant="outlined" color="error" href="https://www.evoesg.com/" target="_blank">
          top up credits
        </Button>
      </Paper>
    </Root>
  );
}
